<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Listagem de Grupos</p>
    </div>
    <div class="q-mt-md row">
      <div class="col-2 q-mr-sm">
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <q-btn
        class="col-2"
        color="positive"
        no-caps
        icon="add"
        @click="tela != 'criar' ? (tela = 'criar') : (tela = 'tabela')"
        label="Criar Novo"
      />

      <q-btn
        color="secondary"
        no-caps
        label="Subir regras por planilha"
        @click="planilha"
        class="q-ml-sm col-2"
      />
    </div>

    <table-grupo v-if="tela == 'tabela'" />

    <div class="row q-mt-md q-ml-sm" v-if="tela == 'criar'">
      <div class="col-md-2 q-ml-sm">
        <q-input dense outlined v-model="nome" label="Nome" />
      </div>
      <div class="col-md-2 q-ml-sm">
        <q-input dense outlined v-model="descricao" label="Descrição" />
      </div>
      <div class="col-md-2 q-ml-sm">
        <q-btn
          color="positive"
          label="Criar"
          class="q-ml-sm"
          dense
          no-caps
          icon="done"
          @click="criar"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import TableGrupo from "../components/TableListarGrupo.vue";
import { useQuasar } from "quasar";
import { ref, onMounted, onActivated, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useFilterPersistence } from "../../../../composables/useFilterPersistence";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { TableGrupo, ListaUnidadesSelect },
  setup() {
    const router = useRouter();
    const $q = useQuasar();
    const store = useStore();
    const tela = ref("tabela");
    const nome = ref("");
    const descricao = ref("");
    const unidade = ref();

    const STORAGE_KEY = "grupo-produtos-listar-filtros";
    const { salvarFiltros, carregarFiltros } = useFilterPersistence(
      STORAGE_KEY,
      { nome, descricao },
      { nome: "", descricao: "" }
    );
    const criar = async () => {
      try {
        await store.dispatch("grupoProdutos/criarGrupo", {
          unidade: store.state.org.unidadeData.id,
          name: nome.value,
          description: descricao.value,
        });

        $q.notify({
          message: "Produto criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        tela.value = "tabela";
      } catch (error) {
        $q.notify({
          message: "Erro a o crair prduto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const regras = async () => {
      router.push({
        name: "grupo-produtos-regras",
      });
    };

    const planilha = async () => {
      router.push({
        name: "grupo-produtos-upload",
      });
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    watch(
      () => nome.value,
      () => {
        salvarFiltros();
      }
    );

    watch(
      () => descricao.value,
      () => {
        salvarFiltros();
      }
    );

    onMounted(() => {
      carregarFiltros();
      getUnidade();
    });

    onActivated(() => {
      carregarFiltros();
    });

    return {
      criar,
      tela,
      nome,
      descricao,
      regras,
      planilha,
      unidade,
    };
  },
};
</script>

<style></style>
